import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=28d4a89a&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=28d4a89a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4a89a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d4a89a')) {
      api.createRecord('28d4a89a', component.options)
    } else {
      api.reload('28d4a89a', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=28d4a89a&scoped=true&", function () {
      api.rerender('28d4a89a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iNiHnDNMJAaC/JS/comp/DateRangeExt.vue"
export default component.exports